/* eslint-disable @typescript-eslint/explicit-function-return-type */
import "./exportmag.css"

import React, { Fragment, useEffect, useState } from "react"
import { render } from "react-dom"

import { getCaseData, getHomeData, getMenuData } from "~/api/data"
import { AppGlobalsProvider } from "~/api/globals"
import { CaseTags } from "~/components/CaseTags/CaseTags"
import { Cookies } from "~/components/Cookies/Cookies"
import { Footer } from "~/components/Footer/Footer"
import { Header } from "~/components/Header/Header"
import { Title } from "~/components/Helpers/Title/Title"
import { LanguageProvider } from "~/components/LanguageProvider/LanguageProvider"
import { ProjectsSlider } from "~/components/ProjectsSlider/ProjectsSlider"

const isEn = !!document.querySelector<HTMLScriptElement>("script[data-dabb-lang=en]")
const API_URL = isEn ? "https://dabb.pro" : "https://beaversbrothers.ru"

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const useApiData = (): any => {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const [context, setContext] = useState<any>()
  useEffect(() => {
    const fetchData = async () => {
      const data = await getHomeData(API_URL)
      const menu = await getMenuData(API_URL)
      return { ...data, menu }
    }
    fetchData()
      .then(setContext)
      .catch((error) => console.error(error))
  }, [])

  return context
}

const whenLayerVisible = function <T extends HTMLElement = HTMLDivElement>(
  selector: string,
  callback: (element: T) => void,
): void {
  const interval = setInterval(() => {
    const layer = document.querySelector<T>(selector)
    if (layer) {
      clearInterval(interval)
      callback(layer)
    }
  }, 250)
}
// TODO: обратный scale для readymag
// const setScale = (layer: HTMLDivElement) => {
//   const isScale = window.innerWidth > 767 && window.innerWidth < 1024
//   if (!isScale) {
//     return
//   }
//   const scale = 1024 / window.innerWidth
//   layer.style.transform = `scale(${scale})`
// }

const inject = () => {
  const sourceTag = document.querySelector<HTMLScriptElement>("script[data-dabb-case-slug]")
  const dabbCaseSlug = sourceTag ? sourceTag.dataset["dabbCaseSlug"] : null

  const MagProvider: React.FC = ({ children }) => {
    const context = useApiData()
    if (!context || !context.menu) {
      return null
    }
    const lang = isEn ? "en" : "ru"

    return (
      <Fragment>
        <AppGlobalsProvider value={context}>
          <LanguageProvider lang={lang}>{children}</LanguageProvider>
        </AppGlobalsProvider>
      </Fragment>
    )
  }

  const ExposeHeader = () => {
    const isMenuDark = !!document.querySelector("script[data-dabb-menu-dark]")

    return (
      <Fragment>
        <MagProvider>
          <Header isMenuDark={isMenuDark} />
        </MagProvider>
      </Fragment>
    )
  }

  const ExposeFooter = () => {
    return (
      <Fragment>
        <MagProvider>
          <Footer />
        </MagProvider>
      </Fragment>
    )
  }

  const ExposeCaseTags = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [context, setContext] = useState<any>()

    useEffect(() => {
      if (!dabbCaseSlug) {
        return
      }

      const fetchData = async () => {
        const data = await getCaseData(API_URL, dabbCaseSlug, true)
        return { ...data }
      }
      fetchData()
        .then(setContext)
        .catch((error) => console.error(error))
    }, [])

    if (!context || !context.related) {
      return null
    }

    const tags = [
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...context.branches.map((v: any) => ({
        title: v.title,
        href: `${API_URL}/branch/${v.slug}`,
      })),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      ...context.services.map((v: any) => ({
        title: v.title,
        href: `${API_URL}/service/${v.slug}`,
      })),
    ]

    return (
      <Fragment>
        <CaseTags tags={tags} />
      </Fragment>
    )
  }

  const ExposeCaseRelated = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [context, setContext] = useState<any>()

    useEffect(() => {
      if (!dabbCaseSlug) {
        return
      }

      const fetchData = async () => {
        const data = await getCaseData(API_URL, dabbCaseSlug, true)
        return { ...data }
      }
      fetchData()
        .then(setContext)
        .catch((error) => console.error(error))
    }, [])

    if (!context || !context.related) {
      return null
    }

    return (
      <Fragment>
        <div className="bb-container">
          {isEn ? (
            <Title type={"h2"} beforeText>
              Next case
            </Title>
          ) : (
            <Title type={"h2"} beforeText readyMagMobile>
              Смотрите следующий&nbsp;проект
            </Title>
          )}
          <ProjectsSlider related={context.related} maxHeight readyMagMobile />
        </div>
      </Fragment>
    )
  }

  const cookie = document.createElement("div")
  const lang = isEn ? "en" : "ru"
  document.body.append(cookie)
  render(<Cookies lang={lang} />, cookie)

  whenLayerVisible("div[data-dabb-layer=menu]", (layer) => {
    const container = document.querySelector<HTMLDivElement>("div[data-dabb-layer=menu]")
    if (container && container.parentElement) {
      container.parentElement.style.pointerEvents = "none"
    }
    render(<ExposeHeader />, layer)
  })
  whenLayerVisible("div[data-dabb-layer=brief]", (layer) => {
    render(<ExposeFooter />, layer)
  })
  whenLayerVisible("div[data-dabb-layer=case-tags]", (layer) => {
    render(<ExposeCaseTags />, layer)
  })
  whenLayerVisible("div[data-dabb-layer=case-related]", (layer) => {
    render(<ExposeCaseRelated />, layer)
  })
  // whenLayerVisible("div[data-dabb-layer=menu] .bb-container", setScale)
  // whenLayerVisible("div[data-dabb-layer=case-related] .bb-container", setScale)
  // whenLayerVisible("div[data-dabb-layer=brief] .bb-container", setScale)
}

window.addEventListener("DOMContentLoaded", inject)
